import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { xepHangTotNghiepApi } from "../../../api/category/xepHangTotNghiepApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eXepHangTotNghiepActionIds } from "../../action-types/category/IXepHangTotNghiepActions";
const mainAction = rootActions.category.xepHangTotNghiep;

export function* xepHangTotNghiepSaga(): any {
    yield takeLatest(eXepHangTotNghiepActionIds.LOAD_START, loadWorker);
    yield takeEvery(eXepHangTotNghiepActionIds.SAVE_START, saveWorker);
    yield takeEvery(eXepHangTotNghiepActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res = yield call(xepHangTotNghiepApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Xếp hạng tốt nghiệp"));
    }
}

function* saveWorker(action: any): any {
    let res;
    const payload = action.payload;
    if (payload.id_xep_hang > 0) {
        res = yield call(xepHangTotNghiepApi.Update, payload.id_xep_hang, payload);
    } else {
        res = yield call(xepHangTotNghiepApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Xếp hạng tốt nghiệp"));
    }
}

function* deleteWorker(action: any): any {
    const id = action.payload;
    const res = yield call(xepHangTotNghiepApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Xếp hạng tốt nghiệp"));
    }
}